import React, { useEffect, useMemo, useState } from 'react';
import TypeAnimation from 'react-type-animation';
import Nav from '../components/Nav';
import NavMobile from '../components/NavMobile';
import Socials from './Socials';

const Header = () => {
  const [bg, setBg] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const next = window.scrollY > 50;
      setBg((prev) => (prev !== next ? next : prev));
    };
    // Initialize once
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const mobileTyping = useMemo(() => (
    <TypeAnimation
      cursor={true}
      speed={120}
      sequence={[
        "Hello there,",
        2200,
        '',
        700,
        "I'm Seth.",
        3200,
        '',
        1500
      ]}
      repeat={Infinity}
      wrapper="span"
    />
  ), []);

  return (
    <header
      className={`${
        bg ? 'bg-tertiary/80 backdrop-blur-md border-b border-white/10' : 'bg-transparent'
      } flex items-center fixed top-0 w-full text-white z-[300] transition-all duration-300 h-20`}
    >
      <div className='container mx-auto h-full flex items-center justify-between relative z-[300]'>
        {/* Desktop brand */}
        <a href='#home' className='hidden lg:inline text-xl font-semibold hover:text-accent transition-colors duration-300'>
          Seth Nuzum
        </a>
        {/* Mobile brand with typing animation */}
        <a href='#home' className='lg:hidden text-xl font-semibold hover:text-accent transition-colors duration-300 pl-2'>
          {mobileTyping}
        </a>
        <div className='hidden lg:block'>
          <Nav />
        </div>
        <div className='hidden lg:block'>
          <Socials />
        </div>
        <div className='lg:hidden'>
          <NavMobile />
        </div>
      </div>
    </header>
  );
};

export default Header;
